var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7319 1.40273C8.13103 0.174315 9.86891 0.174314 10.268 1.40273L11.3948 4.87047C11.5733 5.41983 12.0852 5.79178 12.6629 5.79178H16.3091C17.6007 5.79178 18.1377 7.44459 17.0928 8.20379L14.1429 10.347C13.6756 10.6865 13.4801 11.2883 13.6586 11.8377L14.7853 15.3054C15.1844 16.5338 13.7785 17.5553 12.7335 16.7961L9.78368 14.653C9.31637 14.3134 8.68358 14.3134 8.21626 14.653L5.26642 16.7961C4.22147 17.5553 2.8155 16.5338 3.21464 15.3054L4.34138 11.8377C4.51987 11.2883 4.32433 10.6865 3.85702 10.347L0.907177 8.20379C-0.137772 7.44459 0.39926 5.79178 1.69089 5.79178H5.33709C5.91472 5.79178 6.42666 5.41983 6.60516 4.87047L7.7319 1.40273Z",
    fill: "#3734CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.aaeebb80fd36ed4e1e3ac6df679b7fbd.svg";
export { ForwardRef as ReactComponent };